function adapterTags(dataFromAPI){
  if(dataFromAPI && dataFromAPI.length > 0){
    return dataFromAPI.map(a => {
      return {
        label: a.pilihanTagId ? a.pilihanTagId.nama[0] : a.nama[0] ? a.nama[0] : JSON.stringify(a),
        value: a.pilihanTagId ? a.pilihanTagId.id : a.id
      }
    })
  }

  return []
}

export { adapterTags }
